import Vue from 'vue'
import App from './App.vue'
// import router from './routerManuaConfig'
import store from './store'
import router from './router/index'
// 全局方法
import utils from '../util/utils'
import '../util/global' //全局
import './promissionRouter' //这里进行路由后台获取的模拟
import i18n from './lang' // Internationalization
import Cookies from 'js-cookie'
import preventClick from '../util/clickStateFrom' // 全局防止暴力点击方法

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
// 全局过滤器
import * as filter from '../util/filter'

import VueLazyload from 'vue-lazyload'
import VCharts from 'v-charts'

// 弹窗组件
import layer from 'vue-layer'
import 'vue-layer/lib/vue-layer.css'

import VueClipboard from 'vue-clipboard2'
import Print from 'vue-print-nb'
import axios from 'axios'
import moment from 'moment'
import "./style/common.css"
Vue.prototype.$moment = moment
import Scrollbar from 'element-ui'
// import libraryGoods from '@/components/libraryGoods.vue'
// Vue.component("libraryGoods", libraryGoods)
Vue.use(Scrollbar)
Vue.use(Print);  //注册
Vue.use(VueClipboard)
Vue.use(VCharts)
Vue.use(VueLazyload)
Vue.use(preventClick)
// or with options
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: require('../src/assets/noPic.jpg'),
  attempt: 1
})
// 全局方法
Vue.prototype.$utils = utils

Vue.prototype.$layer = layer(Vue)

Object.keys(filter).forEach(key => {
  Vue.filter(key, filter[key])
})

Vue.use(ElementUI, {
  size: Cookies.get('size') || 'medium', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
});

Vue.prototype.intNum = 123
Vue.prototype.$http = axios
Vue.prototype.getConfigJson = function () {
  this.$http.get("dynamicConfig.json").then((result) => {
    //用一个全局字段保存ApiUrl 也可以用sessionStorage存储
    Vue.prototype.ApiUrl = result.data.server_url
    sessionStorage.setItem('publicPath', result.data.server_url)
  }).catch((error) => { console.log(error) });
}
//如果想使用 mock ，开启这两行即可，想看效果，看登录页的 mock登录功能
// import Mock from './mock'
// Mock.bootstrap();

import 'font-awesome/css/font-awesome.min.css'
import directives from './directives'
Vue.use(directives)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
